import { render, staticRenderFns } from "./Estime.vue?vue&type=template&id=4ecfaedc&scoped=true"
import script from "./Estime.vue?vue&type=script&lang=js"
export * from "./Estime.vue?vue&type=script&lang=js"
import style0 from "./Estime.vue?vue&type=style&index=0&id=4ecfaedc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecfaedc",
  null
  
)

export default component.exports